/**
 * Routes that pin their own action bar to the bottom of the screen on phones
 * (checkout Confirm, listing booking/directions bars, calendar and add-on save
 * bars, the listing wizard, persona and /hh sticky CTAs). The bottom nav would
 * sit on top of those bars, so it is hidden there instead. Matched against the
 * path without the leading slash, query string or fragment.
 */
export const ROUTES_WITH_OWN_ACTION_BAR: readonly RegExp[] = [
  /^booking\/(review|confirm\/)/,
  /^rv-camping\//,
  /^boondocking\//,
  /^hosting\/(calendar|addons)(\/|$)/,
  /^properties\/(new|edit\/)/,
  /^properties\/[^/]+\/(calendar|addons|sites)(\/|$)/,
  /^(hh|farm|land|driveway|winery|brewery|attraction|hobby)$/,
];

export function hasOwnActionBar(url: string): boolean {
  const path = url.split(/[?#]/)[0].replace(/^\/+/, '');
  return ROUTES_WITH_OWN_ACTION_BAR.some((re) => re.test(path));
}
